import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';
import { getMm } from "../../theme/modernMaterialEnterprise";

/**
 * Standardized page loader matching UserAdminPage style.
 * Use across all pages for consistent loading UX.
 * @param {string} message - Loading message (default: "Loading...")
 * @param {React.ReactNode} extra - Optional extra content (e.g. retry button)
 */
export default function PageLoader({ message = 'Loading...', extra = null }) {
  const { isDarkMode } = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        gap: 3,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: '#374151',
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          },
        }}
      />
      <Typography
        sx={{
          fontSize: '1.125rem',
          fontWeight: 500,
          color: getMm(isDarkMode).onSurface,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}
      >
        {message}
      </Typography>
      {extra}
    </Box>
  );
}
